import React from 'react'
import { trimValues } from 'lib/helpers/forms'
import { toBooleanOrNull } from "lib/helpers/parent/forms"

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      updatePickupPerson, // via withMutation
      form: reduxForm, // via withRedux
      pickupPerson // via withQuery
    } = props

    const form = trimValues(reduxForm)

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      updatePickupPerson({
        variables: {
          pickupPersonId: pickupPerson.id,
          input: {
            firstName: form.firstName,
            lastName: form.lastName,
            relationshipToCampers: form.relationshipToCampers,
            legalGuardian: toBooleanOrNull(form.legalGuardian),
            primaryPhone: form.primaryPhone,
            alternatePhone: form.alternatePhone
          }
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
